import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { DownloadMacButton, DownloadWindowsButton, MacDropdown } from './download_buttons'
import SmartscreenModal from './smartscreen_modal'
import { useTranslation, LocalizedLink } from '../lib/i18n'
import { appVersion, GITHUB_REPO } from '../lib/product'

const GITHUB_DOWNLOAD_BASE = `https://github.com/${GITHUB_REPO}/releases/latest/download`

const DOWNLOAD_URLS = {
    windows: `${GITHUB_DOWNLOAD_BASE}/keybreak.exe`,
    macArm64: `${GITHUB_DOWNLOAD_BASE}/keybreak-arm64.dmg`,
    macIntel: `${GITHUB_DOWNLOAD_BASE}/keybreak-x64.dmg`,
}

let versionPromise = null

const fetchVersion = () => {
    if (!versionPromise) {
        versionPromise = fetch(`https://api.github.com/repos/${GITHUB_REPO}/releases/latest`)
            .then(res => res.json())
            .then(data => data.tag_name ? data.tag_name.replace(/^v/, '') : null)
            .catch(() => null)
    }
    return versionPromise
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${({ right }) => right ? 'flex-end' : 'flex-start'};

    @media (max-width: 949px) {
        align-items: center;
    }
`

const ButtonsRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    @media (max-width: 640px) {
        flex-direction: column;
        align-items: center;
    }
`

const MacButtonWrapper = styled.div`
    position: relative;
`

const VersionText = styled.div`
    margin-top: 12px;
    font-size: 13px;
    color: ${({ light }) => light ? 'rgba(255,255,255,0.85)' : '#666'};
    width: 100%;
    text-align: center;
    min-height: 18px;
`

const ChangelogLink = styled(LocalizedLink)`
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 2px;

    &:hover {
        color: ${({ $light }) => $light ? '#ffffff' : '#209fff'};
    }
`

export default ({ right, className = '', light = false, linkVersion = true }) => {
    const [showMacOptions, setShowMacOptions] = useState(false)
    const [version, setVersion] = useState(appVersion)
    const [showSmartscreen, setShowSmartscreen] = useState(false)
    const { t } = useTranslation(undefined, { keyPrefix: 'store' })

    useEffect(() => {
        if (typeof window !== 'undefined') {
            fetchVersion().then(v => { if (v) setVersion(v) })
        }
    }, [])

    const macButton = (
        <MacButtonWrapper
            key="mac"
            onMouseEnter={() => setShowMacOptions(true)}
            onMouseLeave={() => setShowMacOptions(false)}
        >
            <DownloadMacButton href={DOWNLOAD_URLS.macArm64} />
            <MacDropdown
                show={showMacOptions}
                armUrl={DOWNLOAD_URLS.macArm64}
                intelUrl={DOWNLOAD_URLS.macIntel}
            />
        </MacButtonWrapper>
    )

    const windowsButton = (
        <DownloadWindowsButton
            key="win"
            href={DOWNLOAD_URLS.windows}
            onClick={(e) => { e.preventDefault(); setShowSmartscreen(true) }}
        />
    )

    return (
        <Wrapper className={className} right={right}>
            <ButtonsRow>
                {windowsButton}
                {macButton}
            </ButtonsRow>
            <VersionText light={light}>
                {linkVersion ? (
                    <ChangelogLink $light={light} to="/changelog">
                        {t('version', { version })}
                    </ChangelogLink>
                ) : (
                    t('version', { version })
                )}
            </VersionText>
            <SmartscreenModal
                open={showSmartscreen}
                onClose={() => setShowSmartscreen(false)}
                downloadHref={DOWNLOAD_URLS.windows}
            />
        </Wrapper>
    )
}
